'use strict';
var SuggestionStyle;
(function (SuggestionStyle) {
    SuggestionStyle["Compact"] = "compact";
    SuggestionStyle["Standard"] = "standard";
})(SuggestionStyle || (SuggestionStyle = {}));
export default SuggestionStyle;
